/** Integração Syonet desativada. Altere para `true` para reativar (código permanece). */
export const SYONET_ENABLED = false;
